var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0631 9.81561C25.6643 8.58951 24.5305 7.76516 23.2449 7.76516V3.88745C23.2449 3.18809 22.6735 2.6167 21.9741 2.6167H5.47525C4.77589 2.6167 4.20748 3.18809 4.20748 3.88745V14.1397C3.18969 13.9135 1.6511 13.366 1.07079 12.0298L0.734497 12.0714C0.913056 13.5445 2.35046 15.1724 4.21045 15.4015V20.3863C4.21045 21.0857 4.78184 21.6571 5.47822 21.6571H21.9771C22.6765 21.6571 23.2478 21.0857 23.2478 20.3863V13.6933C23.5603 13.6933 23.8669 13.6457 24.1644 13.5475C25.7149 13.0416 26.5661 11.3661 26.0631 9.81561Z",
    fill: "#00A3FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7687 12.3422C22.8788 12.6309 21.9235 12.1428 21.6319 11.253C21.3432 10.3632 21.8313 9.4079 22.7181 9.11625C23.608 8.82758 24.5632 9.31564 24.8549 10.2055C25.1436 11.0953 24.6585 12.0506 23.7687 12.3422Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3731 11.2171C17.9774 12.1099 16.5906 12.7497 15.3317 12.7497C14.0967 12.7497 12.0254 12.4045 12.0254 10.0951H10.5106C10.5106 12.0414 9.79044 12.7497 9.30535 12.7497C8.56136 12.7497 8.10008 12.1277 8.10008 9.03271H6.5853C6.5853 11.1844 5.77881 12.9878 4.68662 13.0176C3.00222 13.0592 2.04395 12.5593 1.60648 11.9641L0.921997 12.0474C1.50827 13.3806 3.22541 14.2645 4.69555 14.2645C5.68358 14.2645 6.52281 13.7437 7.12098 12.845C7.50786 13.6693 8.16853 14.2645 9.30238 14.2645C10.1178 14.2645 10.9332 13.8003 11.46 12.8033C12.2873 13.7378 13.6235 14.2645 15.3317 14.2645C16.8376 14.2645 18.3851 13.6038 19.9028 12.6724L19.3731 11.2171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logoMobile.f379e2320331e9c6b6770de1ccd7763c.svg";
export { ForwardRef as ReactComponent };